<template>
  <section class="language-pair-filter">
    <sk-multiselect :items-list="languages"
                    :preselected-value="filterLangs"
                    :default-value="langDefaultValue"
                    @checkboxeschanged="onInputBoxChanged" />
  </section>
</template>

<script>
  export default {
    data() {
      return {
        filterLangs: []
      };
    },
    computed: {
      languages() { return this.$store.getters.languagesForSelect || []; },
      langDefaultValue() { return this.$gettext('Select a language'); },

    },
    methods: {
      onInputBoxChanged(value) {
        this.filterLangs = [...value];
        if (this.filterLangs === '') {
          return;
        }
        this.params.parentFilterInstance((instance) => {
          instance.onFloatingFilterChanged('inList', value);
        });
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          this.filterLangs = '';
        }
      }
    }
  };
</script>

<style>
.language-pair-filter .sk-select {
  background-color: #fff;
}

.language-pair-filter .sk-select__list {
  width: fit-content;
}

.language-pair-filter .sk-select__value {
  color: #333;
  font-weight: normal;
  font-size: 13px;
}

.language-pair-filter {
  width: 100%;
}
</style>
